import {
  apiParam,
  apiPType,
  API_HOST,
  callProc,
  FETCH_DEFAULT_HEADERS,
  PROC_DEFAULT_TIMEOUT,
  uploadB64,
} from "./APointAPI";
import { __ } from "@/plugins/i18n/index";
import { errorReceived } from "@/services/apointUtil";

import store from "../store/index";

// service call images
export function UploadServiceCallImageUrl(imgID, base64String, fileName) {
  const raw = {
    sessionToken: store.state.api.sessionToken,
    ImgID: imgID,
  };

  const controller = new AbortController();
  const options = {
    method: "POST",
    headers: FETCH_DEFAULT_HEADERS,
    signal: controller.signal,
    body: JSON.stringify(raw),
    redirect: "follow",
  };

  let timeoutID = setTimeout(() => {
    controller.abort();
    return Promise.reject({ error: "connection timeout" });
  }, PROC_DEFAULT_TIMEOUT);

  return fetch(API_HOST + "/BuildApp/GetImageUrl/ServiceCall", options)
    .then((response) => response.text())
    .then((result) => {
      clearTimeout(timeoutID);

      let res = JSON.parse(result);

      if (res.APIResponseCode == 0) {
        let fileUploadUrl = res.APIResponseText;
        let file = ConvertBase64ToJPGFile(base64String, fileName);

        var formData = new FormData();
        formData.append("file", file);

        return new Promise((resolve, reject) => {
          var xhr = new XMLHttpRequest();
          xhr.open("POST", fileUploadUrl, true);
          xhr.onreadystatechange = function() {
            if (xhr.readyState === XMLHttpRequest.DONE) {
              var result = JSON.parse(xhr.responseText);
              if (result.success) {
                SaveLinkOfImgInTable(imgID, result.result.variants[0])
                  .then(() => {
                    resolve(true);
                  })
                  .catch(() => {
                    reject(false);
                  });
              } else UploadToFolder(fileName, base64String, imgID);
            }
          };
          xhr.send(formData);
        });
      } else {
        return Promise.reject({ error: "APIResponseCode is not 0" });
      }
    })
    .catch((error) => {
      return Promise.reject(error);
    });
}

function ConvertBase64ToJPGFile(base64String) {
  base64String = base64String.replace("data:image/jpeg;base64,", "");
  const byteCharacters = window.atob(base64String);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += 512) {
    const slice = byteCharacters.slice(offset, offset + 512);

    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }

  const blob = new Blob(byteArrays, { type: "image/jpeg" });
  return blob;
}

function SaveLinkOfImgInTable(imgId, link) {
  let procParams = [
    apiParam("ImgID", imgId, apiPType.Int),
    apiParam("Link", link, apiPType.VarChar),
  ];
  return new Promise((resolve, reject) => {
    callProc("App_SaveServiceCallImgLink", procParams)
      .then(() => {
        resolve(true);
      })
      .catch((error) => {
        errorReceived(
          "App_SaveServiceCallImgLink",
          error,
          __("An error occurred")
        );
        reject(error);
      });
  });
}

function UploadToFolder(srcFileName, file, FileId) {
  return new Promise((resolve, reject) => {
    uploadB64(-1, -1, -1, srcFileName, file, -1, -FileId)
      .then(() => {
        resolve(true);
      })
      .catch((error) => {
        errorReceived("UploadToFolder", error, __("An error occurred"));
        reject(error);
      });
  });
}

// file atts images
export function App_FileCreate(parentType, parentID, srcFileName, file) {
  let procParams = [
    apiParam("ParentType", parentType, apiPType.Int),
    apiParam("ParentID", parentID, apiPType.Int),
    apiParam("Org_ID", 0, apiPType.Int),
    apiParam("CreatedBy", store.state.api.workerID, apiPType.Int),
    apiParam("SrcFileName", srcFileName, apiPType.NVarChar),
  ];
  return new Promise((resolve, reject) => {
    callProc("apiFileCreate", procParams)
      .then((result) => {
        result = JSON.parse(result);
        resolve(
          UploadFileAttsImageUrl(result.Table[0].fileID, file, srcFileName)
        );
      })
      .catch((error) => {
        errorReceived("apiFileCreate", error, __("An error occurred"));
        reject(error);
      });
  });
}

function UploadFileAttsImageUrl(
  imgID,
  base64String,
  fileName,
  parentType,
  parentID
) {
  const raw = {
    sessionToken: store.state.api.sessionToken,
    ImgID: imgID,
  };

  const controller = new AbortController();
  const options = {
    method: "POST",
    headers: FETCH_DEFAULT_HEADERS,
    signal: controller.signal,
    body: JSON.stringify(raw),
    redirect: "follow",
  };

  let timeoutID = setTimeout(() => {
    controller.abort();
    return Promise.reject({ error: "connection timeout" });
  }, PROC_DEFAULT_TIMEOUT);

  return fetch(API_HOST + "/BuildApp/GetImageUrl/FileAtts", options)
    .then((response) => response.text())
    .then((result) => {
      clearTimeout(timeoutID);

      let res = JSON.parse(result);
      let file = ConvertBase64ToJPGFile(base64String, fileName);

      if (res.APIResponseCode == 0) {
        let fileUploadUrl = res.APIResponseText;

        var formData = new FormData();
        formData.append("file", file);

        return new Promise((resolve, reject) => {
          var xhr = new XMLHttpRequest();
          xhr.open("POST", fileUploadUrl, true);
          xhr.onreadystatechange = function() {
            if (xhr.readyState === XMLHttpRequest.DONE) {
              var result = JSON.parse(xhr.responseText);
              if (result.success) {
                return SaveLinkOfFileAttsInTable(
                  imgID,
                  result.result.variants[0]
                )
                  .then(() => {
                    resolve(true);
                  })
                  .catch(() => {
                    reject(false);
                  });
              } else
                UploadFileToFolder(fileName, file, parentType, parentID, imgID);
            }
          };
          xhr.send(formData);
        });
      } else {
        return Promise.reject({ error: "APIResponseCode is not 0" });
      }
    })
    .catch((error) => {
      return Promise.reject(error);
    });
}

function SaveLinkOfFileAttsInTable(fileId, link) {
  let procParams = [
    apiParam("FileID", fileId, apiPType.Int),
    apiParam("Link", link, apiPType.VarChar),
  ];
  return new Promise((resolve, reject) => {
    callProc("App_SaveFileAttsLink", procParams)
      .then(() => {
        resolve(true);
      })
      .catch((error) => {
        errorReceived("App_SaveFileAttsLink", error, __("An error occurred"));
        reject(error);
      });
  });
}

function UploadFileToFolder(srcFileName, file, parentType, parentID, FileId) {
  return new Promise((resolve, reject) => {
    //14, this.readID, 1, srcFileName, file
    uploadB64(parentType, parentID, 1, srcFileName, file, -1, -FileId)
      .then(() => {
        resolve(true);
      })
      .catch((error) => {
        errorReceived("UploadFileToFolder", error, __("An error occurred"));
        reject(error);
      });
  });
}